import { DateFormatPref } from 'src/app/core/services/date-format.util';

/**
 * Shared helpers for Material DateAdapters that render the numeric date-input field
 * with the user's chosen `display.dateFormat` preset. Both the global
 * FixedFormatDateAdapter and the deadline-picker's LocalizedDateAdapter use these so
 * the "honour the user's date format" logic lives in one place.
 */

function pad(n: number): string {
  return String(n).padStart(2, '0');
}

/** True for the numeric date-input display (day present, numeric month) — the text
 *  field. Textual labels (calendar header month/year) return false and keep their
 *  locale-driven Intl formatting. */
export function isNumericDateInput(opts: Intl.DateTimeFormatOptions): boolean {
  return opts.day != null && (opts.month === 'numeric' || opts.month === '2-digit');
}

/** Render a date with one of the user's concrete date-format presets, reading the
 *  date's local calendar fields (so it round-trips with picker selection/parsing). */
export function formatDatePreset(date: Date, pref: Exclude<DateFormatPref, 'system'>): string {
  const y = date.getFullYear();
  const m = pad(date.getMonth() + 1);
  const d = pad(date.getDate());
  switch (pref) {
    case 'dd/MM/yyyy':
      return `${d}/${m}/${y}`;
    case 'MM/dd/yyyy':
      return `${m}/${d}/${y}`;
    case 'yyyy-MM-dd':
      return `${y}-${m}-${d}`;
  }
}
